/**
 * API Services para Contexts
 * VigosCloud
 * 
 * Serviço para buscar contextos do banco de dados
 */

import axios from 'axios';
import accessLocalStorage from './accessLocalStorage';

/**
 * Busca contextos por tenant
 * @param {string} tenant - Tenant
 * @returns {Promise} Response da API
 */
export const getContextsByTenant = async (tenant) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    console.log('🔍 [CONTEXTS-API] Buscando contextos para tenant:', tenant);
    
    const response = await axios.get(
      `${ipRequest}api/config/dialplan/contexts?tenant=${tenant}`,
      { headers: { Authorization: token } }
    );
    
    console.log(`✅ [CONTEXTS-API] Contextos encontrados:`, response.data);
    return response.data;
  } catch (error) {
    console.error('❌ [CONTEXTS-API] Erro ao buscar contextos:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao buscar contextos',
      data: []
    };
  }
};

/**
 * Busca contextos filtrados por tenant (apenas da tabela contexts)
 * @param {string} tenant - Tenant
 * @returns {Promise} Response da API
 */
export const getContextsFilteredByTenant = async (tenant) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  
  try {
    console.log('🔍 [CONTEXTS-API] Buscando contextos filtrados para tenant:', tenant);
    
    const response = await axios.get(
      `${ipRequest}api/config/dialplan/contexts-filtered?tenant=${tenant}`,
      { headers: { Authorization: token } }
    );
    
    console.log(`✅ [CONTEXTS-API] Contextos filtrados encontrados:`, response.data);
    return response.data;
  } catch (error) {
    console.error('❌ [CONTEXTS-API] Erro ao buscar contextos filtrados:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Erro ao buscar contextos filtrados',
      data: []
    };
  }
};

export default {
  getContextsByTenant,
  getContextsFilteredByTenant
};

